export default "<canvas id=\"items-prices-uyu-chart\"></canvas>\r\n"